import {env} from "../../../../../res/config/env";
import Solr from "../../../../logic/search/solr";
import ReactGA from 'react-ga4';
import HttpClient from "../../../http/HttpClient";
import Platform from "../../../../logic/platform/platform";


const searchRequest = () => {

    const builder = {};

    const getSearchUrl = (input, pageNo, pageSize, priceListID, showCig) => {
        const term = Solr().search(input, pageNo, pageSize, priceListID, showCig);
        if(Platform.isIos()) {
            return env.API_SOLR_URL + term;
        } else {
            return env.API_SOLR_URL + term.replaceAll(" ", "%20");
        }
    }

    const getSolrResults = async(searchUrl) => {
        const response = await HttpClient.client.get(searchUrl);
        return response.data.response;
    }

    builder.setSearchTerm = (searchTerm) => {
        builder.searchTerm = searchTerm;
        return builder;
    }

    builder.setPageNo = (pageNo) => {
        builder.pageNo = pageNo;
        return builder;
    }

    builder.setPageSize = (pageSize) => {
        builder.pageSize = pageSize;
        return builder;
    }

    builder.setPriceList = (priceListID) => {
        builder.priceListID = priceListID;
        return builder;
    }

    builder.setShowCig = (showCig) => {
        builder.showCig = showCig;
        return builder;
    }

    builder.sendRequest = async () => {

        const searchUrl = getSearchUrl(builder.searchTerm, builder.pageNo, builder.pageSize, builder.priceListID, builder.showCig);
        const searchResults = await getSolrResults(searchUrl);

         // Log search to Google Analytics
         ReactGA.event({
            category: 'Search',
            action: 'Performed Search',
            label: builder.searchTerm,
            value: searchResults.numFound
        });
        return {
            searchTerm: builder.searchTerm,
            searchResults: searchResults.docs,
            count: searchResults.numFound
        };
    }

    return builder;

}

export default searchRequest;
